export const selectField = {
  option: {
    class: ['tw-truncate'],
  },
  overlay: {
    class: ['tw-max-w-[75ch]'],
  },
};
